import Section from "@/components/Section";
import { Button } from "@/components/ui/button";
import { Target, Users, Building2, MapPin } from "lucide-react";

const offers = [
  { icon: Target, title: "Coaching privé", desc: "Objectifs précis, prépa physique, progression technique. Un coach dédié pour toi" },
  { icon: Users, title: "Small group", desc: "Prépa sportive, team building ou cours entre amis, en dehors des horaires classiques" },
  { icon: Building2, title: "Coaching entreprise", desc: "Cohésion d'équipe et bien-être au travail. Séances sur mesure pour vos collaborateurs" },
];

export default function CoachingSection() {
  const scrollTo = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <Section id="coaching" className="bg-charcoal text-charcoal-foreground">
      <div className="text-center mb-12">
        <span className="inline-block text-sm font-semibold text-gold tracking-wider mb-2 font-body normal-case">Accompagnement sur mesure</span>
        <h2 className="text-4xl md:text-5xl text-charcoal-foreground">Coaching privé</h2>
      </div>

      <p className="text-center max-w-2xl mx-auto text-charcoal-foreground/70 mb-12 font-body normal-case leading-relaxed">
        Tu as des objectifs précis, une échéance avec des tests physiques ou envie de progresser sur un mouvement en particulier ? Le suivi personnalisé est fait pour toi
      </p>

      <div className="grid md:grid-cols-3 gap-6 mb-10">
        {offers.map((o) => (
          <div key={o.title} className="bg-charcoal-foreground/5 border border-charcoal-foreground/10 rounded-lg p-6 text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group">
            <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-gold/20 transition-colors">
              <o.icon className="text-gold" size={24} />
            </div>
            <h3 className="text-xl text-charcoal-foreground">{o.title}</h3>
            <p className="text-sm text-charcoal-foreground/60 mt-2 font-body normal-case">{o.desc}</p>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-2 text-sm text-charcoal-foreground/60 font-body normal-case mb-6">
        <MapPin size={16} className="text-gold" />
        <span>À la salle · À domicile · En entreprise</span>
      </div>

      <div className="text-center">
        <Button onClick={scrollTo} className="bg-cta text-cta-foreground hover:bg-cta/90 rounded-lg font-semibold px-8">
          Demander un devis
        </Button>
      </div>
    </Section>
  );
}
